var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        padding: '16px',
    },
    rangeLabel: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '16px',
        color: '#323130',
    },
    grid: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-around',
        gap: '8px',
    },
    yearCell: {
        flex: 1,
        padding: '10px 6px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: 'transparent',
        fontSize: '13px',
        fontWeight: 400,
        color: '#323130',
        cursor: 'pointer',
        transition: 'all 0.1s ease',
        textAlign: 'center',
        minWidth: '50px',
    },
    yearDisabled: {
        color: '#a19f9d',
        cursor: 'not-allowed',
        opacity: 0.5,
    },
    yearCurrent: {
        fontWeight: 600,
        color: '#0078d4',
    },
    yearSelected: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
        fontWeight: 600,
    },
};
export default styles;
//# sourceMappingURL=YearPicker.styles.js.map